import React from "react";

function MainApp(props) {


    return (
        <div style={props.Style} id="textArea">
            <div className="input">
                <textarea spellCheck="true" autoCorrect="true" value={props.tAValue} className={props.tAClass} onChange={props.textAreaChange} placeholder="Enter your text here:"></textarea>    
            </div>
            <div className="properties">
              <p> Characters : {props.chars} </p> <p> Words : {props.words} </p> <p> Time to read : {props.time} minutes </p>
            </div>
        </div>
    );
}
export default MainApp;